var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7813 8.17969C14.7813 4.50448 11.8017 1.52486 8.12646 1.52486C4.45126 1.52486 1.47164 4.50448 1.47164 8.17969C1.47164 11.8549 4.45126 14.8345 8.12646 14.8345C11.8017 14.8345 14.7813 11.8549 14.7813 8.17969ZM16.0171 8.17969C16.0171 12.5377 12.4845 16.0703 8.12646 16.0703C3.76844 16.0703 0.23584 12.5377 0.23584 8.17969C0.23584 3.82166 3.76844 0.289062 8.12646 0.289062C12.4845 0.289062 16.0171 3.82166 16.0171 8.17969Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50854 5.27024C7.50854 4.92883 7.78503 4.65234 8.12644 4.65234C8.46786 4.65234 8.74434 4.92883 8.74434 5.27024V7.92365L10.3814 9.56072C10.6228 9.80214 10.6228 10.1929 10.3814 10.4343C10.14 10.6757 9.74925 10.6757 9.50783 10.4343L7.68965 8.61612C7.57372 8.50019 7.50854 8.34328 7.50854 8.17933V5.27024Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.9dae57e2ff706a85e54ce366ac9d2e12.svg";
export { ForwardRef as ReactComponent };